import { AuthenticationService } from "../authenticationService";
import { APIService } from "../apiService";
import { PaginatedPallets, PalletPaginationOptions, PalletRecord, PopulatedPalletRecord } from "src/types";
import { PostPalletRequestBody } from "src/types/api/pallets/postPallet";
import { PatchPalletRequestBody } from "src/types/api/pallets/patchPallet";
import { GetPalletStatsResponse } from "src/types/api/pallets/getPalletStats";
import { PostPalletCompleteRequestBody } from "src/types/api/pallets/postPalletComplete";
import { GetBuildingPalletsResponse } from "src/types/api/pallets/getBuildingPallets";

export interface GetPalletLabelUrlResponse {
  url: string;
  fileName: string;
}

class PalletAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/pallets");
  }

  async postPallet(requestBody: PostPalletRequestBody): Promise<PalletRecord> {
    return await this.jwtRequest("POST", "", requestBody);
  }

  async patchPallet(palletId: string, requestBody: PatchPalletRequestBody): Promise<PalletRecord> {
    return await this.jwtRequest("PATCH", `/${encodeURIComponent(palletId)}`, requestBody);
  }

  async getPallets(queryParams?: PalletPaginationOptions): Promise<PaginatedPallets> {
    return await this.jwtRequest("GET", "", undefined, queryParams);
  }

  async getPalletById(palletId: string): Promise<PopulatedPalletRecord> {
    return await this.jwtRequest("GET", `/${encodeURIComponent(palletId)}`);
  }

  async getPalletStats(): Promise<GetPalletStatsResponse> {
    return await this.jwtRequest("GET", "/stats");
  }

  async getCompletePallets(queryParams?: PalletPaginationOptions): Promise<PaginatedPallets> {
    return await this.jwtRequest("GET", "/complete", undefined, queryParams);
  }

  async getPalletLabelUrl(palletId: string): Promise<GetPalletLabelUrlResponse> {
    return await this.jwtRequest("GET", `/${encodeURIComponent(palletId)}/label-url`);
  }

  async getBuildingPallets(): Promise<GetBuildingPalletsResponse> {
    return await this.jwtRequest("GET", "/building");
  }

  async postPalletComplete(palletId: string, requestBody: PostPalletCompleteRequestBody): Promise<PalletRecord> {
    return await this.jwtRequest("POST", `/${encodeURIComponent(palletId)}/complete`, requestBody);
  }

  async postPalletReopen(palletId: string): Promise<PalletRecord> {
    return await this.jwtRequest("POST", `/${encodeURIComponent(palletId)}/reopen`, {});
  }
}

export { PalletAPIService };
